import { useMemo } from 'react'
import { filterNavForRole, NAV, type NavGroup } from './nav'
import { useSession } from './queries'

/**
 * The rail for the signed-in operator — Logs pages filtered by console role
 * (TM / Master).
 */
export function useConsoleNav(): NavGroup[] {
  const { data: session } = useSession()
  return useMemo(
    () => filterNavForRole(NAV, session?.account.role),
    [session],
  )
}
